import { Component, OnInit, HostBinding, Output, EventEmitter, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../field.interface';
import {fadeIn} from "../../../animations/basic-animation";
@Component({
  selector: 'app-button',
  template: `
    <div class="container-fluid">
      <div [formGroup]="group" class="col-sm-12">
        <app-save-area
          (cancel)="closeForm()"
          [cancelText]="cancelText"
          [confirmFirst]="confirmFirst"
          [confirmText]="confirmMessage"
          [hideSave]="hideSave"
          [isSubmit]="true"
          [loadingMessage]="loadingMessage"
          [saveDisabled]="group?.invalid"
          [saveText]="field?.label || saveText"
          [savingData]="loading"
          [showCancel]="showCancel"
        ></app-save-area>
      </div>
      <!--      <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>-->
    </div>

  `,

  styles: [],
  animations: [fadeIn]
})
export class ButtonComponent implements OnInit {
  @Input() field?: FieldConfig;
  @Input() group: UntypedFormGroup = new UntypedFormGroup({});
  @Input() loading = false;
  @Input() showCancel = false;
  @Input() loadingMessage = 'Please Wait, Loading ...';
  @Input() confirmFirst = false;
  @Input() hideSave = false;
  @Input() confirmMessage = '';
  @Input() cancelText = 'Cancel';
  @Input() saveText = 'Submit';
  @Output() cancelForm = new EventEmitter();
  constructor() {}

  ngOnInit() {

  }
  closeForm() {
    this.cancelForm.emit();
  }
}
